import ChallengeProgressContainer from "@features/dashboard/containers/ChallengeProgressContainer";
import ProgressContainer from "@features/dashboard/containers/ProgressContainer";
/* -----------------Features--------------- */
import { useAppStore } from "@hooks/useAppStore";
const ProgressRoute = () => {
	const isImageChallengeApp = useAppStore(
		(state) => state.app.isImageChallengeApp,
	);

	if (isImageChallengeApp) {
		return <ChallengeProgressContainer />;
	}
	return <ProgressContainer />;
};

export default ProgressRoute;
